<template>
  <MainLayout>
    <router-view />
  </MainLayout>
</template>

<script setup>
import MainLayout from './components/Layout/MainLayout.vue'
import { onMounted, watch, computed } from 'vue'
import { provideLanguage } from '@/composables/useLanguage'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

// Compute current language from route
const currentLanguage = computed(() => {
  return route.path.startsWith('/el') ? 'el' : 'en'
})

// Provide language context to all child components
const { currentLanguage: providedLanguage } = provideLanguage()

// Function to switch language
const switchLanguage = () => {
  const newPath = currentLanguage.value === 'en' 
    ? `/el${route.path}` 
    : route.path.replace('/el', '')
  router.push(newPath)
}

// Sync route language with provided language
watch(currentLanguage, (newLang) => {
  if (providedLanguage.value !== newLang) {
    providedLanguage.value = newLang
    localStorage.setItem('preferredLanguage', newLang)
  }
}, { immediate: true })

onMounted(() => {
  // Check if user has a preferred language stored
  const storedLang = localStorage.getItem('preferredLanguage')
  if (storedLang && storedLang !== currentLanguage.value) {
    // If stored language differs from current route language, redirect
    const newPath = storedLang === 'el' 
      ? `/el${route.path}` 
      : route.path.replace('/el', '')
    router.push(newPath)
  }
})
</script>

<style>
/* Add any global styles here */
</style>
